import React from 'react';
import { Container, Grid, Box, Typography, Button, TextField } from '@mui/material';

export default function BecomeVendor() {
        const [formData, setFormData] = React.useState({
            name: '',
            email: '',
            phone: '',
            description: '',
        });
    
        const handleChange = (e) => {
            const { name, value } = e.target;
            setFormData({
                ...formData,
                [name]: value,
            });
        };
    
        const [result, setResult] = React.useState("");
    
        const onSubmit = async (event) => {
            // event.preventDefault();
    
            // setResult("Sending....");
            // const formData = new FormData(event.target);
    
            // formData.append("access_key", process.env.REACT_APP_ApiWeb3Form);
    
            // const response = await fetch("https://api.web3forms.com/submit", {
            //     method: "POST",
            //     body: formData
            // });
    
            // const data = await response.json();
    
            // if (data.success) {
            //     setResult("Form Submitted Successfully");
            //     event.target.reset();
            // } else {
            //     console.log("Error", data);
            //     setResult(data.message);
            // }
        };

  return (
    <Box sx={{width:"100%",backgroundColor: "#F6F7FB",mb:"60px"}}>
     <Container>
        <Box
          sx={{
            padding: { xs: "40px 0", md: "60px 0" },
          }}
        >
          <Grid container sx={{ width: "100%" }} spacing={4}>
            <Grid item size={{ xs: 12, sm:12 , md: 12 }}>
              <Typography
                variant="h4"
                sx={{
                  fontFamily: `"Quicksand", sans-serif`,
                  fontWeight: 700,
                  fontSize: { xs: "16px", md: "18px", lg: "20px" },
                  color: "#008BFF",
                  textAlign: "center",
                  mb: 1,
                  lineHeight: "24px",
                }}
              >
                Join Us
              </Typography>

              <Typography
                variant="h4"
                sx={{
                  fontFamily: `"Quicksand", sans-serif`,
                  fontWeight: 700,
                  fontSize: { xs: "24px", md: "28px", lg: "32px" },
                  color: "#253D4E",
                  textAlign: "center",
                  lineHeight: "48px",
                  marginBottom: "40px",
                }}
              >
               Become a Vendor
              </Typography>

              <Box
                component="form"
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  gap: 2,
                  width: "100%",
                }}
                onSubmit={onSubmit}
              >
                <Grid container spacing={2}>
                  <Grid item size={{ xs: 12, sm: 6, md: 6 }}>
                    <TextField
                      fullWidth
                      variant="outlined"
                      name="name"
                      placeholder="Your Name"
                      onChange={handleChange}
                      sx={{
                        "& .MuiOutlinedInput-root": {
                          borderRadius: "10px",
                        },
                        backgroundColor: "white",
                      }}
                    />
                  </Grid>
                  <Grid item size={{ xs: 12, sm: 6, md: 6 }}>
                    <TextField
                      fullWidth
                      variant="outlined"
                      name="email"
                      placeholder="Your Email"
                      onChange={handleChange}
                      sx={{
                        "& .MuiOutlinedInput-root": {
                          borderRadius: "10px",
                        },
                        backgroundColor: "white",
                      }}
                    />
                  </Grid>
                  <Grid item size={{ xs: 12, sm: 6, md: 6 }}>
                    <TextField
                      fullWidth
                      variant="outlined"
                      name="phone"
                      placeholder="Your Phone Number"
                      onChange={handleChange}
                      sx={{
                        "& .MuiOutlinedInput-root": {
                          borderRadius: "10px",
                        },
                        backgroundColor: "white",
                      }}
                    />
                  </Grid>
                  <Grid item size={{ xs: 12, sm: 6, md: 6 }}>
                    <TextField
                      fullWidth
                      variant="outlined"
                      name="company"
                      placeholder="Company Name"
                      onChange={handleChange}
                      sx={{
                        "& .MuiOutlinedInput-root": {
                          borderRadius: "10px",
                        },
                        backgroundColor: "white",
                      }}
                    />
                  </Grid>
                  <Grid item size={{ xs: 12, sm: 12, md: 12 }}>
                    <TextField
                      fullWidth
                      variant="outlined"
                      multiline
                      rows={4}
                      name="description"
                      placeholder="Your Message"
                      onChange={handleChange}
                      sx={{
                        "& .MuiOutlinedInput-root": {
                          borderRadius: "10px",
                        },
                        backgroundColor: "white",
                      }}
                    />
                  </Grid>
                </Grid>

                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "center",
                    mt: 2,
                  }}
                >
                  <Button
                    variant="contained"
                    type="submit"
                    sx={{
                      width: "127px",
                      height: "44px",
                      backgroundColor: "#2B3463",
                      borderRadius: "4px",
                      color: "#FFFFFF",
                      fontSize: "12px",
                      fontHeight: "21.6px",
                      fontFamily: `"Quicksand", sans-serif`,
                      fontWeight: "700",
                      padding: "12px 24px",
                      textTransform: "capitalize",
                    }}
                  >
                    Submit
                  </Button>
                </Box>
              </Box>
            </Grid>
            
          </Grid>
        </Box>
      </Container>
      </Box>
  )
}
